import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class FabService {

  visible = new BehaviorSubject(false);
  isAtBottom = new BehaviorSubject(false);

  private scrollFn?: () => void;

  show(scrollFn: () => void) {
    this.scrollFn = scrollFn;
    this.visible.next(true);
  }

  hide() {
    this.visible.next(false);
  }

  scroll() {
    this.scrollFn?.();
  }

  setAtBottom(value: boolean) {
    this.isAtBottom.next(value);
  }
}